<template>
  <div :style="widthStyle">
    <markdown-editor
      class="mdDiv"
      v-model="model"
      :toolbar="toolbar"
      :height="height"
      :spellcheck="1"
      @command:makelink="makeLink"
      @command:addimage="addimage"
      @command:replacebars="replacetext($event, ' | ')"
      @command:replacecommas="replacetext($event, ', ')"
      @command:replacestars="replacetext($event, '*')"
      @command:indent="indent"
      :extend="custom"
    >
      <!-- @input="onInput"
      @change="onChange" --></markdown-editor
    >
    <get-link-dialog
      :open="linkDialog"
      @link="addLink($event)"
      @close="linkDialog = false"
      :externalText="linkSearchText"
    ></get-link-dialog>
    <file-browser
      :openDialog="openFileBrowser"
      :dir="fileBrowserDirectory"
      @close="openFileBrowser = false"
      @fileSelected="imageSelected($event)"
    ></file-browser>
  </div>
</template>

<script>
import Vue from "vue";
import GetLinkDialog from "@/components/adminStuff/GetLinkDialog";
import Editor from "v-markdown-editor";
import "v-markdown-editor/dist/v-markdown-editor.css";
Vue.use(Editor);

export default {
  name: "MdTextarea",
  components: {
    GetLinkDialog,
    FileBrowser: () => import("@/components/adminStuff/FileBrowser"),
  },
  props: {
    value: { type: String, default: "" },
    // if toolbar items are replaced or added you will need the supporting extensions and methods!
    replaceToolbar: null,
    additionalToolbarItems: null,
    maxWidth: null,
    fileBrowserDirectory: { type: String, default: "images" },
    height: { type: String, default: "auto" },
    // mdStyle: { type: String, default: "max-width:95%; width:1000px" },
  },
  data: function () {
    return {
      linkDialog: false,
      activeMdEl: null,
      linkSearchText: null,
      openFileBrowser: false,
      eyedock: "https://www.eyedock.com",
      defaultToolbar:
        "bold italic | heading | numlist bullist indent | link addimage eyedocklink | fullscreen  preview",

      custom: {
        eyedocklink: {
          cmd: "makelink",
          ico: "mdi mdi-eye-plus-outline",
          title: "Link to EyeDock pages",
        },
        indent: {
          cmd: "indent",
          ico: "mdi mdi-format-indent-increase",
          title: "Indent lines",
        },
        replacebars: {
          cmd: "replacebars",
          ico: "mdi mdi-dumbbell",
          title: "Replace bars with dashes",
        },
        replacecommas: {
          cmd: "replacecommas",
          ico: "mdi mdi-comma",
          title: "Replace commas with dashes",
        },
        replacestars: {
          cmd: "replacestars",
          ico: "mdi mdi-asterisk",
          title: "Replace asterisks with dashes",
        },
        addimage: {
          cmd: "addimage",
          ico: "mdi mdi-file-image",
          title: "Add an image",
        },
      },
    };
  },
  methods: {
    // -- for editor --
    makeLink(md) {
      // console.log(md);
      // console.log(module);
      // this.onlyModule = module;
      let selection = md.editor.getSelection();
      this.linkSearchText = selection;
      this.activeMdEl = md;
      this.linkDialog = true;
    },

    addLink(linkObj) {
      let selection = this.activeMdEl.editor.getSelection();
      let name = !selection || selection == "" ? linkObj.name : selection;
      let txt = `[${name}](${linkObj.url})`;
      this.activeMdEl.editor.replaceSelection(txt);
      this.linkDialog = false;
    },

    addimage(md) {
      this.activeMdEl = md;
      this.openFileBrowser = true;
    },
    imageSelected(file) {
      let escapePath = file.path.replaceAll(" ", "%20");
      let txt = `![${file.name}](${this.eyedock + escapePath})`;
      this.activeMdEl.editor.replaceSelection(txt);
    },

    replacetext(md, replace) {
      let selection = md.editor.getSelection();
      let replaced = "- " + selection.replaceAll(replace, "\n- ");
      md.editor.replaceSelection(replaced, "around");
    },
    indent(md) {
      let selection = md.editor.getSelection();
      let replaced = "  " + selection.replaceAll("\n", "\n  ");
      md.editor.replaceSelection(replaced, "around");
    },
  },
  computed: {
    toolbar: function () {
      let toolbar = this.defaultToolbar;
      if (this.replaceToolbar) toolbar = this.replaceToolbar;
      if (this.additionalToolbarItems)
        toolbar += " | " + this.additionalToolbarItems;
      return toolbar;
    },
    widthStyle: function () {
      return this.maxWidth ? `max-width:${this.maxWidth}px` : null;
    },
    model: {
      get() {
        return this.value ? this.value : "";
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped>
.mdDiv >>> .v-md-toolbar {
  display: flex;
}
.mdDiv >>> .btn-outline-secondary {
  border: 1px solid gray;
  margin: 0 1px;
  padding: 0 2px;
  border-radius: 2px;
  width: 24px;
  height: 24px;
}
.mdDiv >>> .v-md-preview ul,
.mdDiv >>> .v-md-preview ol {
  margin-bottom: 1em;
}
.mdDiv >>> .v-md-preview img {
  max-width: 85%;
  margin: 1em;
}
</style>
